var _symbol, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2C0A2214-B810-4F48-9D25-F32403DA89C5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M2.9288878,2.92900753 C6.83410701,-0.976318106 13.16574,-0.976318106 17.0710124,2.9289011 L17.0710124,2.9289011 C20.9763381,6.83427996 20.9762848,13.1659129 17.0710124,17.0711322 C13.1657932,20.9763514 6.83421344,20.9763514 2.92894102,17.0711322 C-0.976278194,13.1659129 -0.97633141,6.83427996 2.9288878,2.92900753 Z M13.4190424,7 L9.26,10.892 L6.7733458,8.56485737 L5,10.2246392 L9.13780687,14.0974636 L9.158,14.077 L9.28123548,14.1923882 L15.1923882,8.65978188 L13.4190424,7 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SUEZ-PCE_UI_Lot1_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02_SUEZ-PCE_UI_client_02_update-mdp",
    transform: "translate(-456.000000, -445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(396.000000, 192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Succes",
    transform: "translate(60.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "currentColor",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-/-Fill-/-Vert-Vivic",
    mask: "url(#mask-2)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)",
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.7142857,
    height: 23.8235294
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.36b05949.svg";
export { ForwardRef as ReactComponent };